export const USER_ROLES = {
  INDIVIDUAL: 'individual',
  AGENT: 'agent',
  STAFF: 'staff',
  ADMIN: 'admin',
  GLOBAL_ADMIN: 'global-admin',
};
